import { Box, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { headCells, Order, OrderBy } from '../utils/modelUtils'

interface ModelListTableHeaderProps {
    selected: string[]
    filteredModelsLength: number
    order: Order
    orderBy: OrderBy
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void
    onRequestSort: (property: OrderBy) => void
}

export const ModelListTableHeader: React.FC<ModelListTableHeaderProps> = ({
    selected,
    filteredModelsLength,
    order,
    orderBy,
    onSelectAllClick,
    onRequestSort
}) => {
    const cellStyles = {
        px: 2,
        py: 0.75,
        fontWeight: 600
    }

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={
                            selected.length > 0 && selected.length < filteredModelsLength
                        }
                        checked={
                            filteredModelsLength > 0 && selected.length === filteredModelsLength
                        }
                        onChange={onSelectAllClick}
                    />
                </TableCell>

                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={cellStyles}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={() => onRequestSort(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}

                <TableCell sx={cellStyles}>Status</TableCell>
                <TableCell sx={cellStyles}>Actions</TableCell>
            </TableRow>
        </TableHead>
    )
}
